var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnhanceText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30027 1.96787H6.13721V9.14304H3.81533V1.96787H0.699421V0H9.30027V1.96787ZM7.23209 12.7246H2.7676V13.7912C2.7676 13.8466 2.74474 13.8997 2.70403 13.9388C2.66333 13.978 2.60812 14 2.55056 14C2.48607 14 2.42811 13.9727 2.38806 13.9295L0.0693077 12.1204C-0.0181923 12.0425 -0.0235901 11.9111 0.0573759 11.8269L2.40311 9.99212C2.4239 9.97349 2.4483 9.95898 2.47492 9.94943C2.50154 9.93989 2.52986 9.93548 2.55825 9.93647C2.58664 9.93746 2.61456 9.94383 2.64039 9.9552C2.66622 9.96658 2.68947 9.98274 2.7088 10.0028C2.74628 10.0412 2.76711 10.0919 2.76704 10.1446L2.7676 11.2112H7.23209V10.1446C7.23209 10.0296 7.32925 9.93582 7.44914 9.93582C7.51107 9.93582 7.56704 9.96096 7.60681 10.0011L9.93096 11.8157C10.0185 11.8941 10.0236 12.0256 9.94203 12.1097C9.29971 12.7276 8.26817 13.345 7.5963 13.9437C7.50908 14.0219 7.37215 14.0172 7.29062 13.933C7.25325 13.8946 7.23253 13.8439 7.23266 13.7912L7.23209 12.7246Z",
    fill: "#3B0532"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceText);
export default __webpack_public_path__ + "static/media/enhance-text.4c1e9e013854e80751ebf197d631b90a.svg";
export { ForwardRef as ReactComponent };